const Marquee = () => {
  return (
    <div className="overflow-hidden whitespace-nowrap w-full absolute bottom-4">
      <div className="marquee">
        <span className="font-light !font-monasanssemicondensed desktop:text-[18px] tablet:text-[16px] mobile:text-[14px]">
          AR • VR • METAVERSE • VIRTUAL ART • EXTENDED REALITY • ARTIFICIAL INTELLIGENCE • SPATIAL COMPUTING • AR • VR • METAVERSE • VIRTUAL ART • EXTENDED REALITY • ARTIFICIAL INTELLIGENCE • SPATIAL COMPUTING • AR • VR • METAVERSE • VIRTUAL ART • EXTENDED REALITY • ARTIFICIAL INTELLIGENCE • SPATIAL COMPUTING • AR • VR • METAVERSE • VIRTUAL ART • EXTENDED REALITY • ARTIFICIAL INTELLIGENCE • SPATIAL COMPUTING • AR • VR • METAVERSE • VIRTUAL ART • EXTENDED REALITY • ARTIFICIAL INTELLIGENCE • SPATIAL COMPUTING • AR • VR • METAVERSE • VIRTUAL ART • EXTENDED REALITY • ARTIFICIAL INTELLIGENCE • SPATIAL COMPUTING • 
        </span>
      </div>
      <style jsx>{`
        @keyframes marquee {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(-50%);
  }
        }
        .marquee {
          display: flex;
          width: 200%;
          animation: marquee 20s linear infinite;
        }
        .marquee span {
          flex-shrink: 0;
          width: 100%;
          padding-right: 2rem;
        }
      `}</style>
    </div>
  );
};

export default Marquee;
